<script lang="ts">
    import { toasts } from '../stores/toast';
    import Toast from './Toast.svelte';
</script>

<div class="toaster" aria-label="Notifications" aria-live="polite">
    {#each $toasts as toast (toast.id)}
        <Toast {toast} />
    {/each}
</div>

<style lang="scss">
    .toaster {
        position: fixed;
        bottom: $spacing-large;
        right: $spacing-large;
        z-index: 1000;
        display: flex;
        flex-direction: column-reverse;
        gap: $spacing-small;
        width: 320px;
        pointer-events: none;

        @media (max-width: 480px) {
            bottom: $spacing-medium;
            left: $spacing-medium;
            right: $spacing-medium;
            width: auto;
        }
    }
</style>
